export const IsNode = (): boolean => false
